import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";

import { useNavigate } from "react-router-dom";

import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../examples/Footer";
import DataTable from "../../../../../examples/Tables/DataTable";

import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDButton from "../../../../../components/MDButton";

import { Alert, Card, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, InputAdornment, MenuItem, Snackbar, Stack, Tooltip } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";

import {
    AccountBalanceOutlined,
    AccountBalanceWalletOutlined,
    AddOutlined,
    DeleteOutlineOutlined,
    DownloadOutlined,
    EditOutlined,
    EuroOutlined,
    PaymentsOutlined,
    RefreshOutlined,
    SearchOutlined,
    WarningAmberRounded,
} from "@mui/icons-material";

import CrudService from "services/cruds-service";

import * as XLSX from "xlsx";

import {
    financeText,
    getFinanceLanguage,
    useFinanceDocumentLang,
    saveFinanceLanguage,
} from "finance-language";

import {
    FinanceKpiTile,
} from "../crm/invoice/finance/shared/FinanceUiKit";
// Koyu hero bandı için (yedekten geri yüklendi)
import { WorkspacePremium } from "@mui/icons-material";
import { CheckCircle } from "@mui/icons-material";
import { CalendarMonth } from "@mui/icons-material";
/* =========================================================
   CONFIG
========================================================= */

const API_URL =
    process.env.REACT_APP_API_URL;

const BANK_DETAIL_API_PATH =
    "/bank-detail";

const COMPANY_CASH_ROUTE =
    "/finance/company-cash";

/* =========================================================
   CONSTANTS
========================================================= */

const currencies = [
    "TRY",
    "USD",
    "EUR",
    "GBP",
];

const emptyForm = {
    bankName: "",
    currency: "TRY",
    iban: "",
    branch: "",
    swift: "",
};

const emptyCashForm = {
    openingBalance: "",
    description: "",
};

/* =========================================================
   COLORS
========================================================= */

const COLORS = {
    navy: "#0B1F3A",

    blue: "#175CD3",
    blueLight: "#EFF8FF",

    green: "#027A48",
    greenLight: "#ECFDF3",

    red: "#B42318",
    redLight: "#FEF3F2",

    amber: "#B54708",
    amberLight: "#FFFAEB",

    purple: "#6941C6",
    purpleLight: "#F4F3FF",

    text: "#101828",
    subtext: "#667085",

    border: "#E4E7EC",
    page: "#F5F7FA",

    white: "#FFFFFF",
};

/* =========================================================
   COMMON CARD STYLE
========================================================= */

const cardSx = {
    borderRadius: "10px",

    background: COLORS.white,

    border: "1px solid rgba(15, 23, 42, 0.12)",

    boxShadow: "none",

    overflow: "hidden",
};

/* =========================================================
   BUTTON SYSTEM
========================================================= */

const buttonColors = {
    primary: {
        backgroundColor:
        COLORS.blue,

        hoverBackgroundColor:
            "#134BAA",

        color:
        COLORS.white,

        borderColor:
        COLORS.blue,

        hoverBorderColor:
            "#134BAA",
    },

    success: {
        backgroundColor:
        COLORS.green,

        hoverBackgroundColor:
            "#05603A",

        color:
        COLORS.white,

        borderColor:
        COLORS.green,

        hoverBorderColor:
            "#05603A",
    },

    danger: {
        backgroundColor:
        COLORS.red,

        hoverBackgroundColor:
            "#912018",

        color:
        COLORS.white,

        borderColor:
        COLORS.red,

        hoverBorderColor:
            "#912018",
    },

    secondary: {
        backgroundColor:
        COLORS.white,

        hoverBackgroundColor:
            "#F9FAFB",

        color:
        COLORS.navy,

        borderColor:
        COLORS.border,

        hoverBorderColor:
            "#98A2B3",
    },

    editIcon: {
        backgroundColor:
        COLORS.purpleLight,

        hoverBackgroundColor:
            "#E9E7FD",

        color:
        COLORS.purple,

        borderColor:
            "#D9D6FE",

        hoverBorderColor:
            "#BDB4FE",
    },

    deleteIcon: {
        backgroundColor:
        COLORS.redLight,

        hoverBackgroundColor:
            "#FEE4E2",

        color:
        COLORS.red,

        borderColor:
            "#FECDCA",

        hoverBorderColor:
            "#FDA29B",
    },

    cashIcon: {
        backgroundColor:
        COLORS.greenLight,

        hoverBackgroundColor:
            "#D1FADF",

        color:
        COLORS.green,

        borderColor:
            "#ABEFC6",

        hoverBorderColor:
            "#75E0A7",
    },

    connectCashIcon: {
        backgroundColor:
        COLORS.blueLight,

        hoverBackgroundColor:
            "#D1E9FF",

        color:
        COLORS.blue,

        borderColor:
            "#B2DDFF",

        hoverBorderColor:
            "#84CAFF",
    },
};

/* =========================================================
   BUTTON STYLE
========================================================= */

const getButtonStyle = ({
                            backgroundColor,
                            hoverBackgroundColor,

                            color = "#ffffff",

                            borderColor =
                                backgroundColor,

                            hoverBorderColor =
                                hoverBackgroundColor,

                            isIcon = false,

                            fullWidth = false,
                        }) => ({
    ...(isIcon
        ? {
            width: 36,
            minWidth: 36,
            height: 36,
            p: 0,
        }
        : {
            minWidth: 112,
            height: 42,
            px: 2,
        }),

    ...(fullWidth && {
        width: "100%",
    }),

    color,

    backgroundColor,

    border:
        `1px solid ${borderColor}`,

    borderRadius: "10px",

    textTransform: "none",

    fontWeight: 700,

    fontSize: "13px",

    boxShadow: "none",

    transition:
        "background-color .2s ease, border-color .2s ease, color .2s ease",

    "& .MuiButton-startIcon": {
        color,
    },

    "& svg": {
        color,
    },

    "&:hover": {
        color,

        backgroundColor:
        hoverBackgroundColor,

        borderColor:
        hoverBorderColor,

        boxShadow: "none",
    },

    "&.Mui-disabled": {
        color: "#98A2B3",

        backgroundColor:
            "#F2F4F7",

        borderColor:
        COLORS.border,

        boxShadow: "none",
    },

    "&.Mui-disabled svg": {
        color: "#98A2B3",
    },
});

/* =========================================================
   HELPERS
========================================================= */

const turkishToUpper = (
    value = ""
) =>
    String(value)
        .replace(/i/g, "İ")
        .replace(/ş/g, "Ş")
        .replace(/ğ/g, "Ğ")
        .replace(/ü/g, "Ü")
        .replace(/ö/g, "Ö")
        .replace(/ç/g, "Ç")
        .toUpperCase();

const formatIBAN = (
    value = ""
) => {
    const cleaned =
        String(value)
            .replace(
                /[^A-Za-z0-9]/g,
                ""
            )
            .toUpperCase()
            .slice(0, 26);

    return (
        cleaned
            .match(/.{1,4}/g)
            ?.join(" ") || ""
    );
};

const validateTRIban = (
    iban = ""
) => {
    const normalized =
        String(iban)
            .replace(/\s+/g, "")
            .toUpperCase();

    if (
        !normalized.startsWith(
            "TR"
        ) ||
        normalized.length !== 26 ||
        !/^[A-Z0-9]+$/.test(
            normalized
        )
    ) {
        return false;
    }

    /*
     * ISO 13616 mod-97 kontrolü:
     * ilk 4 karakter sona taşınır, harfler sayıya çevrilir (A=10...Z=35)
     * ve sonuç 97'ye bölündüğünde kalan 1 olmalıdır.
     */
    const rearranged =
        normalized.slice(4) +
        normalized.slice(0, 4);

    let remainder = 0;

    for (const char of rearranged) {
        const digits =
            /[A-Z]/.test(char)
                ? String(
                    char.charCodeAt(0) - 55
                )
                : char;

        for (const digit of digits) {
            remainder =
                (remainder * 10 +
                    Number(digit)) %
                97;
        }
    }

    return remainder === 1;
};

const getTRIbanError = (
    iban = ""
) => {
    if (!iban) {
        return "";
    }

    if (validateTRIban(iban)) {
        return "";
    }

    const normalized =
        String(iban)
            .replace(/\s+/g, "")
            .toUpperCase();

    return normalized.length === 26 &&
    normalized.startsWith("TR")
        ? financeText("TR IBAN checksum is invalid. Please check the number.")
        : financeText("TR IBAN must contain 26 characters.");
};

const normalizeSwift = (
    value = ""
) =>
    String(value)
        .replace(
            /[^A-Za-z0-9]/g,
            ""
        )
        .toUpperCase()
        .slice(0, 11);

const validateSwift = (
    value = ""
) => {
    if (!value) {
        return true;
    }

    const normalized =
        normalizeSwift(value);

    return (
        normalized.length === 8 ||
        normalized.length === 11
    );
};

/* =========================================================
   MONEY FORMAT
========================================================= */

const formatMoney = (
    value,
    currency = "EUR"
) => {
    try {
        return new Intl.NumberFormat(
            "tr-TR",
            {
                style: "currency",
                currency,

                minimumFractionDigits:
                    2,

                maximumFractionDigits:
                    2,
            }
        ).format(
            Number(value) || 0
        );
    } catch {
        return `${Number(value) || 0} ${currency}`;
    }
};

/* =========================================================
   API -> VIEW
========================================================= */

const toView = (raw) => {
    const doc =
        raw?.attributes
            ? {
                id: raw.id,

                ...(raw.attributes ||
                    {}),
            }
            : raw || {};

    const cashAccount =
        doc.cashAccount || null;

    return {
        id: String(
            doc.id ||
            doc._id ||
            ""
        ),

        bankName:
            doc.bankName || "",

        currency:
            doc.currency ||
            "TRY",

        iban: formatIBAN(
            doc.iban || ""
        ),

        branch:
            doc.branch || "",

        swift:
            doc.swift || "",

        cashAccountId:
            cashAccount?.id ||
            cashAccount?._id ||
            null,

        cashAccountName:
            cashAccount?.name ||
            "",

        cashBalance:
            Number(
                cashAccount
                    ?.currentBalance
            ) || 0,

        openingBalance:
            Number(
                cashAccount
                    ?.openingBalance
            ) || 0,

        cashActive:
            Boolean(
                cashAccount &&
                cashAccount
                    .isActive !==
                false
            ),

        cashAccount:
            cashAccount || null,
    };
};

/* =========================================================
   VIEW -> API
========================================================= */

const toPayload = (
    data
) => ({
    bankName:
        turkishToUpper(
            data?.bankName?.trim() ||
            ""
        ),

    currency:
        data?.currency ||
        "TRY",

    iban: String(
        data?.iban || ""
    )
        .replace(/\s+/g, "")
        .toUpperCase(),

    branch:
        turkishToUpper(
            data?.branch?.trim() ||
            ""
        ),

    swift:
        normalizeSwift(
            data?.swift || ""
        ),
});

/* =========================================================
   ERROR HELPER
========================================================= */

const getErrorMessage = (
    error,

    fallback =
        financeText("An unexpected error occurred.")
) =>
    error?.response?.data
        ?.errors?.[0]?.detail ||
    error?.response?.data
        ?.message ||
    error?.data?.errors?.[0]
        ?.detail ||
    error?.data?.message ||
    error?.message ||
    fallback;

/* =========================================================
   EXCEL EXPORT
========================================================= */

const exportToExcel = (
    data = []
) => {
    const exportRows =
        data.map((row) => ({
            BANK:
            row.bankName,

            CURRENCY:
            row.currency,

            IBAN:
            row.iban,

            BRANCH:
            row.branch,

            SWIFT:
            row.swift,

            "CASH STATUS":
                row.cashAccountId
                    ? "Connected"
                    : "Not Connected",

            BALANCE:
                row.cashAccountId
                    ? row.cashBalance
                    : "",

            "BALANCE CURRENCY":
                row.cashAccountId
                    ? row.currency
                    : "",
        }));

    const worksheet =
        XLSX.utils.json_to_sheet(
            exportRows
        );

    worksheet["!cols"] = [
        { wch: 28 },
        { wch: 12 },
        { wch: 38 },
        { wch: 28 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
    ];

    const workbook =
        XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Bank Details"
    );

    const date =
        new Date();

    const timestamp = [
        date.getFullYear(),

        String(
            date.getMonth() +
            1
        ).padStart(2, "0"),

        String(
            date.getDate()
        ).padStart(2, "0"),

        "_",

        String(
            date.getHours()
        ).padStart(2, "0"),

        String(
            date.getMinutes()
        ).padStart(2, "0"),
    ].join("");

    XLSX.writeFile(
        workbook,

        `Filenders_Bank_Details_${timestamp}.xlsx`
    );
};

/* =========================================================
   METRIC CARD
========================================================= */

// Görünüm Finance kitindeki KPI kartıyla aynı (bkz. shared/FinanceUiKit.js)
const MetricCard = (props) => <FinanceKpiTile {...props} />;

/* =========================================================
   MAIN COMPONENT
========================================================= */

const BankDetails = () => {
    const navigate =
        useNavigate();

    const [financeLanguage, setFinanceLanguageState] = useState(getFinanceLanguage);

    useFinanceDocumentLang(financeLanguage);

    const changeFinanceLanguage = (event) => {
        const nextLanguage = event.target.value === "tr" ? "tr" : "en";
        saveFinanceLanguage(nextLanguage);
        setFinanceLanguageState(nextLanguage);
    };

    const token =
        localStorage.getItem(
            "token"
        );

    /* =====================================================
       MAIN STATES
    ===================================================== */

    const [
        rows,
        setRows,
    ] = useState([]);

    const [
        form,
        setForm,
    ] = useState(
        emptyForm
    );

    const [
        createModal,
        setCreateModal,
    ] = useState(false);

    const [
        query,
        setQuery,
    ] = useState("");

    const [
        edit,
        setEdit,
    ] = useState(null);

    const [
        deleteTarget,
        setDeleteTarget,
    ] = useState(null);

    const [
        loading,
        setLoading,
    ] = useState(false);

    const [
        saving,
        setSaving,
    ] = useState(false);

    const [
        lastUpdated,
        setLastUpdated,
    ] = useState(
        new Date()
    );

    /* =====================================================
       COMPANY CASH STATES
    ===================================================== */

    const [
        selectedBank,
        setSelectedBank,
    ] = useState(null);

    const [
        cashAccountModal,
        setCashAccountModal,
    ] = useState(false);

    const [
        cashAccountForm,
        setCashAccountForm,
    ] = useState(
        emptyCashForm
    );

    const [
        connectingCash,
        setConnectingCash,
    ] = useState(false);

    /* =====================================================
       NOTIFICATION
    ===================================================== */

    const [
        notification,
        setNotification,
    ] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const showNotification =
        useCallback(
            (
                message,
                severity =
                    "success"
            ) => {
                setNotification({
                    open: true,
                    message,
                    severity,
                });
            },

            []
        );

    const closeNotification =
        () => {
            setNotification(
                (previous) => ({
                    ...previous,
                    open: false,
                })
            );
        };

    /* =====================================================
       CREATE MODAL
    ===================================================== */

    const openCreateModal =
        () => {
            setForm(
                emptyForm
            );

            setCreateModal(
                true
            );
        };

    const closeCreateModal =
        () => {
            if (saving) {
                return;
            }

            setCreateModal(
                false
            );

            setForm(
                emptyForm
            );
        };

    /* =====================================================
       CONNECT CASH API
    ===================================================== */

    const connectBankToCashAccount =
        useCallback(
            async (
                bankId,
                payload
            ) => {
                const baseUrl =
                    String(
                        API_URL ||
                        ""
                    ).replace(
                        /\/+$/,
                        ""
                    );

                const response =
                    await fetch(
                        `${baseUrl}${BANK_DETAIL_API_PATH}/${bankId}/connect-cash`,
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",

                                Authorization:
                                    `Bearer ${token}`,
                            },

                            body:
                                JSON.stringify(
                                    payload
                                ),
                        }
                    );

                let body = null;

                try {
                    body =
                        await response.json();
                } catch {
                    body = null;
                }

                if (
                    !response.ok
                ) {
                    const error =
                        new Error(
                            body
                                ?.errors?.[0]
                                ?.detail ||
                            body
                                ?.message ||
                            financeText("Bank account could not be connected to Company Cash.")
                        );

                    error.data =
                        body;

                    throw error;
                }

                return body;
            },

            [token]
        );

    /* =====================================================
       FETCH BANK DETAILS
    ===================================================== */

    const refreshList =
        useCallback(
            async () => {
                try {
                    setLoading(
                        true
                    );

                    const response =
                        await CrudService.getBankDetails();

                    const source =
                        Array.isArray(
                            response
                        )
                            ? response
                            : Array.isArray(
                                response
                                    ?.data
                            )
                                ? response.data
                                : Array.isArray(
                                    response
                                        ?.data
                                        ?.data
                                )
                                    ? response
                                        .data
                                        .data
                                    : [];

                    setRows(
                        source.map(
                            toView
                        )
                    );

                    setLastUpdated(
                        new Date()
                    );
                } catch (error) {
                    showNotification(
                        getErrorMessage(
                            error,

                            financeText("Bank details could not be loaded.")
                        ),

                        "error"
                    );
                } finally {
                    setLoading(
                        false
                    );
                }
            },

            [
                showNotification,
            ]
        );

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    /* =====================================================
       SEARCH
    ===================================================== */

    const filteredRows =
        useMemo(() => {
            const q =
                turkishToUpper(
                    query.trim()
                );

            if (!q) {
                return rows;
            }

            return rows.filter(
                (row) =>
                    [
                        row.bankName,
                        row.currency,
                        row.iban,
                        row.branch,
                        row.swift,

                        row.cashAccountId
                            ? "CONNECTED"
                            : "NOT CONNECTED",
                    ].some(
                        (value) =>
                            turkishToUpper(
                                String(
                                    value ||
                                    ""
                                )
                            ).includes(
                                q
                            )
                    )
            );
        }, [
            rows,
            query,
        ]);

    /* =====================================================
       SUMMARY
    ===================================================== */

    const currencySummary =
        useMemo(() => {
            return currencies.reduce(
                (
                    result,
                    currency
                ) => {
                    result[
                        currency
                        ] =
                        rows.filter(
                            (
                                row
                            ) =>
                                row.currency ===
                                currency
                        ).length;

                    return result;
                },

                {}
            );
        }, [rows]);

    const connectedCashCount =
        useMemo(
            () =>
                rows.filter(
                    (row) =>
                        Boolean(
                            row.cashAccountId
                        )
                ).length,

            [rows]
        );

    /* =====================================================
       CREATE VALIDATION
    ===================================================== */

    const formErrors =
        useMemo(
            () => ({
                iban:
                    getTRIbanError(
                        form.iban
                    ),

                swift:
                    form.swift &&
                    !validateSwift(
                        form.swift
                    )
                        ? financeText("SWIFT must contain 8 or 11 characters.")
                        : "",
            }),

            [
                form.iban,
                form.swift,
            ]
        );

    const createFormValid =
        useMemo(() => {
            return (
                !!form.bankName.trim() &&
                !!form.branch.trim() &&
                validateTRIban(
                    form.iban
                ) &&
                validateSwift(
                    form.swift
                )
            );
        }, [form]);

    /* =====================================================
       CREATE BANK
    ===================================================== */

    const handleAdd =
        async () => {
            if (
                !createFormValid
            ) {
                showNotification(
                    financeText("Please complete the required fields correctly."),

                    "warning"
                );

                return;
            }

            try {
                setSaving(
                    true
                );

                await CrudService.createBankDetail(
                    toPayload(
                        form
                    )
                );

                setCreateModal(
                    false
                );

                setForm(
                    emptyForm
                );

                await refreshList();

                showNotification(
                    financeText("Bank account created successfully.")
                );
            } catch (error) {
                showNotification(
                    getErrorMessage(
                        error,

                        financeText("Bank account could not be created.")
                    ),

                    "error"
                );
            } finally {
                setSaving(
                    false
                );
            }
        };

    /* =====================================================
       EDIT VALIDATION
    ===================================================== */

    const editErrors =
        useMemo(() => {
            if (!edit) {
                return {
                    iban: "",
                    swift: "",
                };
            }

            return {
                iban:
                    getTRIbanError(
                        edit.iban
                    ),

                swift:
                    edit.swift &&
                    !validateSwift(
                        edit.swift
                    )
                        ? financeText("SWIFT must contain 8 or 11 characters.")
                        : "",
            };
        }, [edit]);

    const editFormValid =
        useMemo(() => {
            if (!edit) {
                return false;
            }

            return (
                !!edit.bankName?.trim() &&
                !!edit.branch?.trim() &&
                validateTRIban(
                    edit.iban
                ) &&
                validateSwift(
                    edit.swift
                )
            );
        }, [edit]);

    /* =====================================================
       UPDATE BANK
    ===================================================== */

    const confirmEdit =
        async () => {
            if (
                !edit ||
                !editFormValid
            ) {
                return;
            }

            try {
                setSaving(
                    true
                );

                await CrudService.updateBankDetail(
                    toPayload(
                        edit
                    ),

                    edit.id
                );

                setEdit(
                    null
                );

                await refreshList();

                showNotification(
                    financeText("Bank account updated successfully.")
                );
            } catch (error) {
                showNotification(
                    getErrorMessage(
                        error,

                        financeText("Bank account could not be updated.")
                    ),

                    "error"
                );
            } finally {
                setSaving(
                    false
                );
            }
        };

    /* =====================================================
       DELETE BANK
    ===================================================== */

    const confirmDelete =
        async () => {
            if (
                !deleteTarget?.id
            ) {
                return;
            }

            if (
                deleteTarget.cashAccountId
            ) {
                showNotification(
                    financeText("This bank account is connected to Company Cash and cannot be deleted."),

                    "warning"
                );

                return;
            }

            try {
                setSaving(
                    true
                );

                await CrudService.deleteBankDetail(
                    deleteTarget.id
                );

                setDeleteTarget(
                    null
                );

                await refreshList();

                showNotification(
                    financeText("Bank account deleted successfully.")
                );
            } catch (error) {
                showNotification(
                    getErrorMessage(
                        error,

                        financeText("Bank account could not be deleted.")
                    ),

                    "error"
                );
            } finally {
                setSaving(
                    false
                );
            }
        };

    /* =====================================================
       OPEN / CONNECT COMPANY CASH
    ===================================================== */

    const handleCashAccount =
        (bank) => {
            if (
                bank.cashAccountId
            ) {
                navigate(
                    `${COMPANY_CASH_ROUTE}?account=${bank.cashAccountId}`
                );

                return;
            }

            setSelectedBank(
                bank
            );

            setCashAccountForm(
                emptyCashForm
            );

            setCashAccountModal(
                true
            );
        };

    const closeCashAccountModal =
        () => {
            if (
                connectingCash
            ) {
                return;
            }

            setCashAccountModal(
                false
            );

            setSelectedBank(
                null
            );

            setCashAccountForm(
                emptyCashForm
            );
        };

    const confirmCashConnection =
        async () => {
            if (
                !selectedBank?.id
            ) {
                return;
            }

            const openingBalance =
                cashAccountForm
                    .openingBalance ===
                ""
                    ? 0
                    : Number(
                        cashAccountForm.openingBalance
                    );

            if (
                !Number.isFinite(
                    openingBalance
                )
            ) {
                showNotification(
                    financeText("Opening balance must be a valid number."),

                    "warning"
                );

                return;
            }

            try {
                setConnectingCash(
                    true
                );

                await connectBankToCashAccount(
                    selectedBank.id,

                    {
                        openingBalance,

                        description:
                            cashAccountForm.description
                                ?.trim() ||
                            "",
                    }
                );

                setCashAccountModal(
                    false
                );

                setSelectedBank(
                    null
                );

                setCashAccountForm(
                    emptyCashForm
                );

                await refreshList();

                showNotification(
                    financeText("Bank account connected to Company Cash successfully.")
                );
            } catch (error) {
                showNotification(
                    getErrorMessage(
                        error,

                        financeText("Bank account could not be connected to Company Cash.")
                    ),

                    "error"
                );
            } finally {
                setConnectingCash(
                    false
                );
            }
        };

    /* =====================================================
       COLUMNS
    ===================================================== */

    const columns =
        useMemo(
            () => [
                {
                    Header:
                        financeText("BANK"),

                    accessor:
                        "bankName",

                    Cell: ({
                               value,
                           }) => (
                        <MDBox
                            display="flex"
                            alignItems="center"
                            gap={1.1}
                            py={0.35}
                        >
                            <MDBox
                                width={40}
                                height={40}
                                borderRadius="8px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                flexShrink={0}
                                sx={{
                                    color:
                                    COLORS.blue,

                                    background:
                                    COLORS.blueLight,

                                    border:
                                        "1px solid #B2DDFF",
                                }}
                            >
                                <AccountBalanceOutlined
                                    sx={{
                                        fontSize:
                                            "19px !important",
                                    }}
                                />
                            </MDBox>

                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                sx={{
                                    color:
                                    COLORS.text,
                                }}
                            >
                                {value}
                            </MDTypography>
                        </MDBox>
                    ),
                },

                {
                    Header:
                        financeText("CURRENCY"),

                    accessor:
                        "currency",

                    Cell: ({
                               value,
                           }) => {
                        const configs = {
                            TRY: {
                                color:
                                COLORS.amber,

                                background:
                                COLORS.amberLight,
                            },

                            USD: {
                                color:
                                COLORS.green,

                                background:
                                COLORS.greenLight,
                            },

                            EUR: {
                                color:
                                COLORS.blue,

                                background:
                                COLORS.blueLight,
                            },

                            GBP: {
                                color:
                                COLORS.purple,

                                background:
                                COLORS.purpleLight,
                            },
                        };

                        const config =
                            configs[
                                value
                                ] ||
                            configs.EUR;

                        return (
                            <Chip
                                label={
                                    value
                                }
                                size="small"
                                sx={{
                                    color:
                                    config.color,

                                    background:
                                    config.background,

                                    fontWeight:
                                        800,

                                    minWidth:
                                        60,
                                }}
                            />
                        );
                    },
                },

                {
                    Header:
                        financeText("IBAN"),

                    accessor:
                        "iban",

                    Cell: ({
                               value,
                           }) => (
                        <MDTypography
                            variant="button"
                            fontWeight="medium"
                            sx={{
                                color:
                                COLORS.text,

                                fontFamily:
                                    "monospace",

                                whiteSpace:
                                    "nowrap",
                            }}
                        >
                            {value}
                        </MDTypography>
                    ),
                },

                {
                    Header:
                        financeText("BRANCH"),

                    accessor:
                        "branch",

                    Cell: ({
                               value,
                           }) => (
                        <MDBox>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                sx={{
                                    color:
                                    COLORS.text,
                                }}
                            >
                                {value ||
                                    "-"}
                            </MDTypography>

                            <MDTypography
                                variant="caption"
                                display="block"
                                sx={{
                                    color:
                                    COLORS.subtext,
                                }}
                            >
                                {financeText("Bank branch")}
                            </MDTypography>
                        </MDBox>
                    ),
                },

                {
                    Header:
                        financeText("SWIFT"),

                    accessor:
                        "swift",

                    Cell: ({
                               value,
                           }) => (
                        <MDTypography
                            variant="button"
                            fontWeight="bold"
                            sx={{
                                color:
                                COLORS.navy,

                                fontFamily:
                                    "monospace",
                            }}
                        >
                            {value ||
                                "-"}
                        </MDTypography>
                    ),
                },

                {
                    Header:
                        financeText("CASH STATUS"),

                    accessor:
                        "cashActive",

                    disableSortBy:
                        true,

                    Cell: ({
                               row,
                           }) => {
                        const item =
                            row.original;

                        return (
                            <Chip
                                size="small"
                                label={financeText(
                                    item.cashAccountId
                                        ? "Connected"
                                        : "Not Connected"
                                )}
                                sx={{
                                    color:
                                        item.cashAccountId
                                            ? COLORS.green
                                            : COLORS.amber,

                                    background:
                                        item.cashAccountId
                                            ? COLORS.greenLight
                                            : COLORS.amberLight,

                                    border:
                                        item.cashAccountId
                                            ? "1px solid #ABEFC6"
                                            : "1px solid #FEDF89",

                                    fontWeight:
                                        700,
                                }}
                            />
                        );
                    },
                },

                {
                    Header:
                        financeText("BALANCE"),

                    accessor:
                        "cashBalance",

                    Cell: ({
                               row,
                           }) => {
                        const item =
                            row.original;

                        if (
                            !item.cashAccountId
                        ) {
                            return (
                                <MDTypography
                                    variant="caption"
                                    sx={{
                                        color:
                                        COLORS.subtext,
                                    }}
                                >
                                    {financeText("Not connected")}
                                </MDTypography>
                            );
                        }

                        return (
                            <MDBox>
                                <MDTypography
                                    variant="button"
                                    fontWeight="bold"
                                    sx={{
                                        color:
                                            item.cashBalance >=
                                            0
                                                ? COLORS.green
                                                : COLORS.red,

                                        whiteSpace:
                                            "nowrap",
                                    }}
                                >
                                    {formatMoney(
                                        item.cashBalance,

                                        item.currency
                                    )}
                                </MDTypography>

                                <MDTypography
                                    variant="caption"
                                    display="block"
                                    sx={{
                                        color:
                                        COLORS.subtext,
                                    }}
                                >
                                    {financeText("Current balance")}
                                </MDTypography>
                            </MDBox>
                        );
                    },
                },

                {
                    Header:
                        financeText("ACTIONS"),

                    id:
                        "actions",

                    disableSortBy:
                        true,

                    Cell: ({
                               row,
                           }) => {
                        const item =
                            row.original;

                        return (
                            <MDBox
                                display="flex"
                                justifyContent="flex-end"
                                gap={0.65}
                            >
                                <Tooltip
                                    title={financeText(
                                        item.cashAccountId
                                            ? "Open Company Cash"
                                            : "Connect to Company Cash"
                                    )}
                                    arrow
                                >
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            handleCashAccount(
                                                item
                                            )
                                        }
                                        sx={getButtonStyle({
                                            ...(item.cashAccountId
                                                ? buttonColors.cashIcon
                                                : buttonColors.connectCashIcon),

                                            isIcon:
                                                true,
                                        })}
                                    >
                                        <AccountBalanceWalletOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip
                                    title={financeText("Edit bank account")}
                                    arrow
                                >
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            setEdit({
                                                ...item,
                                            })
                                        }
                                        sx={getButtonStyle({
                                            ...buttonColors.editIcon,

                                            isIcon:
                                                true,
                                        })}
                                    >
                                        <EditOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip
                                    title={financeText(
                                        item.cashAccountId
                                            ? "Connected accounts cannot be deleted"
                                            : "Delete bank account"
                                    )}
                                    arrow
                                >
                                    <span>
                                        <IconButton
                                            size="small"
                                            disabled={Boolean(
                                                item.cashAccountId
                                            )}
                                            onClick={() =>
                                                setDeleteTarget(
                                                    item
                                                )
                                            }
                                            sx={getButtonStyle({
                                                ...buttonColors.deleteIcon,

                                                isIcon:
                                                    true,
                                            })}
                                        >
                                            <DeleteOutlineOutlined fontSize="small" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </MDBox>
                        );
                    },
                },
            ],

            [financeLanguage]
        );

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox
                pt={6}
                pb={3}
                sx={{
                    minHeight:
                        "100vh",

                    background:
                    COLORS.page,

                    mx: {
                        xs: -2,
                        md: -3,
                    },

                    px: {
                        xs: 2,
                        md: 3,
                    },
                }}
            >
                {/* =================================================
                    HERO
                ================================================= */}

                <Card
                    sx={{
                        borderRadius:
                            "22px",

                        color:
                        COLORS.white,

                        background:
                            "linear-gradient(125deg, #081A31 0%, #0D2D52 52%, #175CD3 135%)",

                        boxShadow:
                            "0 18px 46px rgba(11, 31, 58, 0.22)",

                        overflow:
                            "hidden",

                        position:
                            "relative",

                        mb: 3,

                        "&::after":
                            {
                                content:
                                    '""',

                                position:
                                    "absolute",

                                width:
                                    360,

                                height:
                                    360,

                                borderRadius:
                                    "50%",

                                right:
                                    -130,

                                top:
                                    -180,

                                background:
                                    "rgba(255,255,255,.07)",
                            },

                        "&::before":
                            {
                                content:
                                    '""',

                                position:
                                    "absolute",

                                width:
                                    230,

                                height:
                                    230,

                                borderRadius:
                                    "50%",

                                right:
                                    120,

                                bottom:
                                    -170,

                                background:
                                    "rgba(11,165,236,.16)",
                            },
                    }}
                >
                    <MDBox
                        p={{
                            xs: 2.5,
                            md: 3.5,
                        }}
                        position="relative"
                        zIndex={1}
                    >
                        <Grid
                            container
                            spacing={3}
                            alignItems="center"
                        >
                            <Grid
                                item
                                xs={12}
                                lg={7}
                            >
                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    mb={1}
                                >
                                    <MDBox
                                        width={34}
                                        height={34}
                                        borderRadius="10px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        sx={{
                                            background:
                                                "rgba(255,255,255,.12)",
                                        }}
                                    >
                                        <WorkspacePremium
                                            sx={{
                                                color:
                                                    "#FFFFFF",

                                                fontSize:
                                                    20,
                                            }}
                                        />
                                    </MDBox>

                                    <MDTypography
                                        variant="caption"
                                        fontWeight="bold"
                                        sx={{
                                            color:
                                                "rgba(255,255,255,.72)",

                                            letterSpacing:
                                                ".12em",
                                        }}
                                    >
                                        {financeText("CORPORATE BANK OPERATIONS")}
                                    </MDTypography>
                                </MDBox>

                                <MDTypography
                                    variant="h2"
                                    fontWeight="bold"
                                    sx={{
                                        color:
                                            "#FFFFFF",

                                        lineHeight:
                                            1.12,
                                    }}
                                >
                                    {financeText("Filenders Bank Details")}
                                </MDTypography>

                                <MDTypography
                                    variant="body2"
                                    mt={1}
                                    sx={{
                                        color:
                                            "rgba(255,255,255,.72)",

                                        maxWidth:
                                            720,
                                    }}
                                >
                                    {financeText(
                                        "Manage company bank accounts, currencies, IBAN, SWIFT codes and Company Cash connections from one professional workspace."
                                    )}
                                </MDTypography>

                                <MDBox
                                    display="flex"
                                    alignItems="center"
                                    flexWrap="wrap"
                                    gap={1}
                                    mt={2.5}
                                >
                                    <Chip
                                        icon={
                                            <CheckCircle
                                                sx={{
                                                    color:
                                                        "#75E0A7 !important",
                                                }}
                                            />
                                        }
                                        label={`${rows.length} ${financeText("bank accounts")}`}
                                        sx={{
                                            color:
                                                "#FFFFFF",

                                            background:
                                                "rgba(255,255,255,.10)",

                                            border:
                                                "1px solid rgba(255,255,255,.14)",
                                        }}
                                    />

                                    <Chip
                                        icon={
                                            <AccountBalanceWalletOutlined
                                                sx={{
                                                    color:
                                                        "#75E0A7 !important",
                                                }}
                                            />
                                        }
                                        label={`${connectedCashCount} ${financeText("connected to Company Cash")}`}
                                        sx={{
                                            color:
                                                "#FFFFFF",

                                            background:
                                                "rgba(255,255,255,.10)",

                                            border:
                                                "1px solid rgba(255,255,255,.14)",
                                        }}
                                    />

                                    <Chip
                                        icon={
                                            <CalendarMonth
                                                sx={{
                                                    color:
                                                        "#B2DDFF !important",
                                                }}
                                            />
                                        }
                                        label={`${financeText("Updated")} ${lastUpdated.toLocaleTimeString(
                                            [],
                                            {
                                                hour:
                                                    "2-digit",

                                                minute:
                                                    "2-digit",
                                            }
                                        )}`}
                                        sx={{
                                            color:
                                                "#FFFFFF",

                                            background:
                                                "rgba(255,255,255,.10)",

                                            border:
                                                "1px solid rgba(255,255,255,.14)",
                                        }}
                                    />
                                </MDBox>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                lg={5}
                            >
                                <MDBox
                                    p={2}
                                    borderRadius="16px"
                                    sx={{
                                        background:
                                            "rgba(255,255,255,.09)",

                                        border:
                                            "1px solid rgba(255,255,255,.13)",

                                        backdropFilter:
                                            "blur(8px)",
                                    }}
                                >
                                    <MDBox
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mb={1}
                                    >
                                        <MDTypography
                                            variant="caption"
                                            fontWeight="bold"
                                            sx={{
                                                color:
                                                    "rgba(255,255,255,.72)",
                                            }}
                                        >
                                            {financeText("TOTAL BANK ACCOUNTS")}
                                        </MDTypography>

                                        <AccountBalanceOutlined
                                            sx={{
                                                color:
                                                    "#B2DDFF",
                                            }}
                                        />
                                    </MDBox>

                                    <MDTypography
                                        variant="h3"
                                        fontWeight="bold"
                                        sx={{
                                            color:
                                                "#FFFFFF",
                                        }}
                                    >
                                        {rows.length}
                                    </MDTypography>

                                    <MDTypography
                                        variant="caption"
                                        sx={{
                                            color:
                                                "rgba(255,255,255,.68)",
                                        }}
                                    >
                                        TRY{" "}
                                        {currencySummary.TRY ||
                                            0}
                                        {" · "}
                                        USD{" "}
                                        {currencySummary.USD ||
                                            0}
                                        {" · "}
                                        EUR{" "}
                                        {currencySummary.EUR ||
                                            0}
                                        {" · "}
                                        GBP{" "}
                                        {currencySummary.GBP ||
                                            0}
                                    </MDTypography>

                                    <MDBox
                                        display="flex"
                                        gap={1}
                                        mt={2}
                                        alignItems="stretch"
                                    >
                                        <MDBox
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                p: "4px",
                                                background: "rgba(255,255,255,.10)",
                                                border: "1px solid rgba(255,255,255,.20)",
                                                borderRadius: "12px",
                                                boxShadow: "inset 0 1px 2px rgba(0,0,0,.10)",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {[
                                                { value: "en", label: "EN", flag: "/flags/gb.svg", title: "English" },
                                                { value: "tr", label: "TR", flag: "/flags/tr.svg", title: "Türkçe" },
                                            ].map((language) => (
                                                <MDBox
                                                    key={language.value}
                                                    component="button"
                                                    type="button"
                                                    onClick={() =>
                                                        changeFinanceLanguage({
                                                            target: { value: language.value },
                                                        })
                                                    }
                                                    title={language.title}
                                                    sx={{
                                                        appearance: "none",
                                                        WebkitAppearance: "none",
                                                        border: "none",
                                                        outline: "none",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "7px",
                                                        height: 38,
                                                        minWidth: 76,
                                                        px: 1.15,
                                                        borderRadius: "8px",
                                                        background:
                                                            financeLanguage === language.value
                                                                ? "#FFFFFF"
                                                                : "transparent",
                                                        color:
                                                            financeLanguage === language.value
                                                                ? COLORS.navy
                                                                : "#FFFFFF",
                                                        boxShadow:
                                                            financeLanguage === language.value
                                                                ? "0 3px 10px rgba(0,0,0,.18)"
                                                                : "none",
                                                    }}
                                                >
                                                    <MDBox
                                                        component="img"
                                                        src={language.flag}
                                                        alt={language.title}
                                                        sx={{
                                                            width: 24,
                                                            height: 17,
                                                            objectFit: "cover",
                                                            borderRadius: "3px",
                                                            display: "block",
                                                        }}
                                                    />
                                                    <MDTypography
                                                        component="span"
                                                        sx={{
                                                            fontSize: "12px",
                                                            fontWeight: 800,
                                                            color: "inherit",
                                                            lineHeight: 1,
                                                        }}
                                                    >
                                                        {language.label}
                                                    </MDTypography>
                                                </MDBox>
                                            ))}
                                        </MDBox>

                                        <MDButton
                                            variant="contained"
                                            onClick={
                                                openCreateModal
                                            }
                                            sx={{
                                                background:
                                                    "#FFFFFF !important",

                                                color:
                                                    `${COLORS.navy} !important`,

                                                flex: 1,

                                                boxShadow:
                                                    "none",
                                            }}
                                        >
                                            <AddOutlined
                                                sx={{
                                                    mr: 0.5,
                                                }}
                                            />

                                            {financeText("Add New Account")}
                                        </MDButton>

                                        <Tooltip title={financeText("Refresh bank accounts")}>
                                            <span style={{ display: "inline-flex" }}><IconButton
                                                onClick={
                                                    refreshList
                                                }
                                                disabled={
                                                    loading
                                                }
                                                sx={{
                                                    color:
                                                        "#FFFFFF",

                                                    border:
                                                        "1px solid rgba(255,255,255,.18)",

                                                    borderRadius:
                                                        "10px",
                                                }}
                                            >
                                                {loading ? (
                                                    <CircularProgress
                                                        size={20}
                                                        sx={{
                                                            color:
                                                                "#FFFFFF",
                                                        }}
                                                    />
                                                ) : (
                                                    <RefreshOutlined />
                                                )}
                                            </IconButton></span>
                                        </Tooltip>
                                    </MDBox>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>

                {/* =================================================
                    CURRENCY CARDS
                ================================================= */}

                <Grid
                    container
                    spacing={2.5}
                >
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={3}
                    >
                        <MetricCard
                            title={financeText("TRY Accounts")}
                            value={
                                currencySummary.TRY ||
                                0
                            }
                            subtitle={financeText("Turkish Lira accounts")}
                            icon={
                                <PaymentsOutlined />
                            }
                            tone="amber"
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={3}
                    >
                        <MetricCard
                            title={financeText("USD Accounts")}
                            value={
                                currencySummary.USD ||
                                0
                            }
                            subtitle={financeText("US Dollar accounts")}
                            icon={
                                <PaymentsOutlined />
                            }
                            tone="green"
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={3}
                    >
                        <MetricCard
                            title={financeText("EUR Accounts")}
                            value={
                                currencySummary.EUR ||
                                0
                            }
                            subtitle={financeText("Euro accounts")}
                            icon={
                                <EuroOutlined />
                            }
                            tone="blue"
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={3}
                    >
                        <MetricCard
                            title={financeText("GBP Accounts")}
                            value={
                                currencySummary.GBP ||
                                0
                            }
                            subtitle={financeText("British Pound accounts")}
                            icon={
                                <PaymentsOutlined />
                            }
                            tone="purple"
                        />
                    </Grid>
                </Grid>

                {/* =================================================
                    FULL WIDTH TABLE
                ================================================= */}

                <Card
                    sx={{
                        ...cardSx,

                        mt: 2.5,

                        width: "100%",
                    }}
                >
                    <MDBox p={3}>
                        {/* HEADER */}

                        <MDBox
                            display="flex"
                            alignItems={{
                                xs: "flex-start",

                                md: "center",
                            }}
                            justifyContent="space-between"
                            flexDirection={{
                                xs: "column",

                                md: "row",
                            }}
                            gap={1.5}
                            mb={2.5}
                        >
                            <MDBox
                                display="flex"
                                alignItems="center"
                                gap={1}
                            >
                                <MDBox
                                    width={42}
                                    height={42}
                                    borderRadius="8px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{
                                        color:
                                        COLORS.navy,

                                        background:
                                            "#EEF2F6",

                                        border:
                                            "1px solid #CDD5DF",
                                    }}
                                >
                                    <AccountBalanceOutlined />
                                </MDBox>

                                <MDBox>
                                    <MDTypography
                                        variant="h6"
                                        fontWeight="bold"
                                        sx={{
                                            color:
                                            COLORS.text,
                                        }}
                                    >
                                        {financeText("Bank Accounts")}
                                    </MDTypography>

                                    <MDTypography
                                        variant="caption"
                                        sx={{
                                            color:
                                            COLORS.subtext,
                                        }}
                                    >
                                        {financeText(
                                            "Manage bank accounts, balances and Company Cash connections."
                                        )}
                                    </MDTypography>
                                </MDBox>
                            </MDBox>

                            {/* ACTION BUTTONS */}

                            <MDBox
                                display="flex"
                                flexWrap="wrap"
                                gap={1}
                            >
                                <MDButton
                                    variant="contained"
                                    onClick={
                                        refreshList
                                    }
                                    disabled={
                                        loading
                                    }
                                    sx={getButtonStyle(
                                        buttonColors.secondary
                                    )}
                                >
                                    <RefreshOutlined
                                        sx={{
                                            mr: 0.6,
                                        }}
                                    />

                                    {financeText("Refresh")}
                                </MDButton>

                                <MDButton
                                    variant="contained"
                                    onClick={() =>
                                        exportToExcel(
                                            filteredRows
                                        )
                                    }
                                    disabled={
                                        !filteredRows.length
                                    }
                                    sx={getButtonStyle(
                                        buttonColors.success
                                    )}
                                >
                                    <DownloadOutlined
                                        sx={{
                                            mr: 0.6,
                                        }}
                                    />

                                    {financeText("Export Excel")}
                                </MDButton>
                            </MDBox>
                        </MDBox>

                        {/* SEARCH */}

                        <TextField
                            fullWidth
                            size="small"
                            label={financeText("Search")}
                            placeholder={financeText("Bank, currency, IBAN, branch, SWIFT or cash status...")}
                            value={
                                query
                            }
                            onChange={(
                                event
                            ) =>
                                setQuery(
                                    event
                                        .target
                                        .value
                                )
                            }
                            InputProps={{
                                startAdornment:
                                    (
                                        <InputAdornment position="start">
                                            <SearchOutlined
                                                fontSize="small"
                                                sx={{
                                                    color:
                                                    COLORS.subtext,
                                                }}
                                            />
                                        </InputAdornment>
                                    ),
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",

                                        background:
                                            "#FFFFFF",
                                    },
                            }}
                        />

                        {/* INFO BAR */}

                        <MDBox
                            mt={2}
                            p={1.5}
                            borderRadius="8px"
                            display="flex"
                            alignItems={{
                                xs: "flex-start",

                                md: "center",
                            }}
                            justifyContent="space-between"
                            flexDirection={{
                                xs: "column",

                                md: "row",
                            }}
                            gap={1}
                            sx={{
                                background:
                                    "#F9FAFB",

                                border: `1px solid ${COLORS.border}`,
                            }}
                        >
                            <MDTypography
                                variant="caption"
                                sx={{
                                    color:
                                    COLORS.subtext,
                                }}
                            >
                                {financeText("Showing")}{" "}
                                <strong
                                    style={{
                                        color:
                                        COLORS.text,
                                    }}
                                >
                                    {
                                        filteredRows.length
                                    }
                                </strong>{" "}
                                {financeText("of")}{" "}
                                <strong
                                    style={{
                                        color:
                                        COLORS.text,
                                    }}
                                >
                                    {
                                        rows.length
                                    }
                                </strong>{" "}
                                {financeText("bank accounts")}
                            </MDTypography>

                            <MDBox
                                display="flex"
                                flexWrap="wrap"
                                gap={0.7}
                            >
                                <Chip
                                    size="small"
                                    label={`${financeText("Connected")} ${connectedCashCount}`}
                                    sx={{
                                        color:
                                        COLORS.green,

                                        background:
                                        COLORS.greenLight,

                                        border:
                                            "1px solid #ABEFC6",

                                        fontWeight:
                                            700,
                                    }}
                                />

                                <Chip
                                    size="small"
                                    label={`${financeText("Not Connected")} ${
                                        rows.length -
                                        connectedCashCount
                                    }`}
                                    sx={{
                                        color:
                                        COLORS.amber,

                                        background:
                                        COLORS.amberLight,

                                        border:
                                            "1px solid #FEDF89",

                                        fontWeight:
                                            700,
                                    }}
                                />
                            </MDBox>
                        </MDBox>

                        <Divider
                            sx={{
                                my: 2.5,
                            }}
                        />

                        {/* TABLE */}

                        {loading ? (
                            <MDBox
                                minHeight={300}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <CircularProgress />
                            </MDBox>
                        ) : (
                            <MDBox
                                sx={{
                                    "& .MuiTableContainer-root":
                                        {
                                            border: `1px solid ${COLORS.border}`,

                                            borderRadius:
                                                "10px",

                                            overflowX:
                                                "auto",

                                            boxShadow:
                                                "none",
                                        },

                                    "& table":
                                        {
                                            width:
                                                "100%",

                                            minWidth:
                                                1180,

                                            borderCollapse:
                                                "separate",

                                            borderSpacing:
                                                0,
                                        },

                                    "& table thead":
                                        {
                                            background:
                                                "#F8FAFC",
                                        },

                                    "& table thead th":
                                        {
                                            background:
                                                "transparent",

                                            color:
                                                "#475467 !important",

                                            fontSize:
                                                "10px !important",

                                            fontWeight:
                                                "800 !important",

                                            letterSpacing:
                                                ".085em",

                                            paddingTop:
                                                "15px !important",

                                            paddingBottom:
                                                "15px !important",

                                            borderBottom: `1px solid ${COLORS.border} !important`,
                                        },

                                    "& table tbody td":
                                        {
                                            paddingTop:
                                                "14px !important",

                                            paddingBottom:
                                                "14px !important",

                                            borderBottom:
                                                "1px solid #F0F2F5 !important",

                                            verticalAlign:
                                                "middle",
                                        },

                                    "& table tbody tr":
                                        {
                                            background:
                                                "#FFFFFF",

                                            transition:
                                                "background .18s ease, box-shadow .18s ease",
                                        },

                                    "& table tbody tr:nth-of-type(even)":
                                        {
                                            background:
                                                "#FCFCFD",
                                        },

                                    "& table tbody tr:hover":
                                        {
                                            background:
                                                "#F5F8FF !important",

                                            boxShadow:
                                                "inset 3px 0 0 #175CD3",
                                        },

                                    "& table tbody tr:last-child td":
                                        {
                                            borderBottom:
                                                "0 !important",
                                        },

                                    "& .MuiTablePagination-root":
                                        {
                                            borderTop: `1px solid ${COLORS.border}`,

                                            background:
                                                "#FCFCFD",
                                        },
                                }}
                            >
                                <DataTable
                                    table={{
                                        columns,

                                        rows:
                                        filteredRows,
                                    }}
                                    canSearch={
                                        false
                                    }
                                    entriesPerPage={{
                                        defaultValue:
                                            10,

                                        entries:
                                            [
                                                5,
                                                10,
                                                25,
                                                50,
                                                100,
                                            ],
                                    }}
                                    showTotalEntries
                                    isSorted
                                    noEndBorder
                                />
                            </MDBox>
                        )}
                    </MDBox>
                </Card>
            </MDBox>

            {/* =====================================================
                CREATE BANK ACCOUNT DIALOG
            ===================================================== */}

            <Dialog
                open={
                    createModal
                }
                onClose={
                    closeCreateModal
                }
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius:
                            "10px",

                        overflow:
                            "hidden",
                    },
                }}
            >
                <DialogTitle>
                    <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1.2}
                    >
                        <MDBox
                            width={44}
                            height={44}
                            borderRadius="8px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                color:
                                COLORS.blue,

                                background:
                                COLORS.blueLight,

                                border:
                                    "1px solid #B2DDFF",
                            }}
                        >
                            <AddOutlined />
                        </MDBox>

                        <MDBox>
                            <MDTypography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                    color:
                                    COLORS.text,
                                }}
                            >
                                {financeText("Add New Bank Account")}
                            </MDTypography>

                            <MDTypography
                                variant="caption"
                                sx={{
                                    color:
                                    COLORS.subtext,
                                }}
                            >
                                {financeText("Create a new company bank account.")}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </DialogTitle>

                <DialogContent>
                    <Stack
                        spacing={2}
                        mt={1}
                    >
                        {/* BANK NAME */}

                        <TextField
                            label={financeText("Bank Name")}
                            placeholder={financeText("Example: T. GARANTİ BANKASI")}
                            size="small"
                            fullWidth
                            value={
                                form.bankName
                            }
                            onChange={(
                                event
                            ) =>
                                setForm(
                                    (
                                        previous
                                    ) => ({
                                        ...previous,

                                        bankName:
                                        event
                                            .target
                                            .value,
                                    })
                                )
                            }
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",
                                    },
                            }}
                        />

                        {/* CURRENCY */}

                        <TextField
                            select
                            label={financeText("Currency")}
                            size="small"
                            fullWidth
                            value={
                                form.currency
                            }
                            onChange={(
                                event
                            ) =>
                                setForm(
                                    (
                                        previous
                                    ) => ({
                                        ...previous,

                                        currency:
                                        event
                                            .target
                                            .value,
                                    })
                                )
                            }
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",
                                    },
                            }}
                        >
                            {currencies.map(
                                (
                                    currency
                                ) => (
                                    <MenuItem
                                        key={
                                            currency
                                        }
                                        value={
                                            currency
                                        }
                                    >
                                        {
                                            currency
                                        }
                                    </MenuItem>
                                )
                            )}
                        </TextField>

                        {/* IBAN */}

                        <TextField
                            label={financeText("IBAN")}
                            placeholder="TR00 0000 0000 0000 0000 0000 00"
                            size="small"
                            fullWidth
                            value={
                                form.iban
                            }
                            error={Boolean(
                                formErrors.iban
                            )}
                            helperText={
                                formErrors.iban ||
                                financeText("TR IBAN - 26 characters")
                            }
                            onChange={(
                                event
                            ) =>
                                setForm(
                                    (
                                        previous
                                    ) => ({
                                        ...previous,

                                        iban:
                                            formatIBAN(
                                                event
                                                    .target
                                                    .value
                                            ),
                                    })
                                )
                            }
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",
                                    },
                            }}
                        />

                        {/* SWIFT */}

                        <TextField
                            label={financeText("SWIFT Code")}
                            placeholder={financeText("Example: TGBATRISXXX")}
                            size="small"
                            fullWidth
                            value={
                                form.swift
                            }
                            error={Boolean(
                                formErrors.swift
                            )}
                            helperText={
                                formErrors.swift ||
                                financeText("8 or 11 characters")
                            }
                            onChange={(
                                event
                            ) =>
                                setForm(
                                    (
                                        previous
                                    ) => ({
                                        ...previous,

                                        swift:
                                            normalizeSwift(
                                                event
                                                    .target
                                                    .value
                                            ),
                                    })
                                )
                            }
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",
                                    },
                            }}
                        />

                        {/* BRANCH */}

                        <TextField
                            label={financeText("Branch")}
                            placeholder={financeText("Example: MERSİN SANAYİ")}
                            size="small"
                            fullWidth
                            value={
                                form.branch
                            }
                            onChange={(
                                event
                            ) =>
                                setForm(
                                    (
                                        previous
                                    ) => ({
                                        ...previous,

                                        branch:
                                        event
                                            .target
                                            .value,
                                    })
                                )
                            }
                            sx={{
                                "& .MuiOutlinedInput-root":
                                    {
                                        borderRadius:
                                            "11px",
                                    },
                            }}
                        />

                        <Alert
                            severity="info"
                            sx={{
                                borderRadius:
                                    "8px",
                            }}
                        >
                            {financeText(
                                "After creating the bank account, you can connect it to Company Cash and define its opening balance."
                            )}
                        </Alert>
                    </Stack>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        gap: 1,
                    }}
                >
                    <MDButton
                        variant="contained"
                        disabled={
                            saving
                        }
                        onClick={
                            closeCreateModal
                        }
                        sx={getButtonStyle(
                            buttonColors.secondary
                        )}
                    >
                        {financeText("Cancel")}
                    </MDButton>

                    <MDButton
                        variant="contained"
                        disabled={
                            saving ||
                            !createFormValid
                        }
                        onClick={
                            handleAdd
                        }
                        sx={getButtonStyle(
                            buttonColors.primary
                        )}
                    >
                        {saving ? (
                            <CircularProgress
                                size={16}
                                sx={{
                                    color:
                                        "#FFFFFF",

                                    mr: 0.7,
                                }}
                            />
                        ) : (
                            <AddOutlined
                                sx={{
                                    mr: 0.7,
                                }}
                            />
                        )}

                        {financeText("Add Account")}
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* =====================================================
                CONNECT TO COMPANY CASH DIALOG
            ===================================================== */}

            <Dialog
                open={
                    cashAccountModal
                }
                onClose={
                    closeCashAccountModal
                }
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius:
                            "10px",
                    },
                }}
            >
                <DialogTitle>
                    <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1.2}
                    >
                        <MDBox
                            width={44}
                            height={44}
                            borderRadius="8px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                color:
                                COLORS.green,

                                background:
                                COLORS.greenLight,

                                border:
                                    "1px solid #ABEFC6",
                            }}
                        >
                            <AccountBalanceWalletOutlined />
                        </MDBox>

                        <MDBox>
                            <MDTypography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                    color:
                                    COLORS.text,
                                }}
                            >
                                {financeText("Connect to Company Cash")}
                            </MDTypography>

                            <MDTypography
                                variant="caption"
                                sx={{
                                    color:
                                    COLORS.subtext,
                                }}
                            >
                                {financeText("Create a Cash Account linked to this bank account.")}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </DialogTitle>

                <DialogContent>
                    {selectedBank && (
                        <Stack
                            spacing={2}
                            mt={1}
                        >
                            <MDBox
                                p={2}
                                borderRadius="8px"
                                sx={{
                                    background:
                                        "#F9FAFB",

                                    border: `1px solid ${COLORS.border}`,
                                }}
                            >
                                <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    gap={2}
                                >
                                    <MDBox
                                        minWidth={0}
                                    >
                                        <MDTypography
                                            variant="button"
                                            fontWeight="bold"
                                            sx={{
                                                color:
                                                COLORS.text,
                                            }}
                                        >
                                            {
                                                selectedBank.bankName
                                            }
                                        </MDTypography>

                                        <MDTypography
                                            variant="caption"
                                            display="block"
                                            sx={{
                                                color:
                                                COLORS.subtext,

                                                fontFamily:
                                                    "monospace",

                                                mt: 0.4,
                                            }}
                                        >
                                            {
                                                selectedBank.iban
                                            }
                                        </MDTypography>

                                        <MDTypography
                                            variant="caption"
                                            display="block"
                                            sx={{
                                                color:
                                                COLORS.subtext,

                                                mt: 0.25,
                                            }}
                                        >
                                            {selectedBank.branch ||
                                                financeText("No branch")}{" "}
                                            ·{" "}
                                            {selectedBank.swift ||
                                                financeText("No SWIFT")}
                                        </MDTypography>
                                    </MDBox>

                                    <Chip
                                        label={
                                            selectedBank.currency
                                        }
                                        size="small"
                                        sx={{
                                            color:
                                            COLORS.blue,

                                            background:
                                            COLORS.blueLight,

                                            fontWeight:
                                                800,

                                            border:
                                                "1px solid #B2DDFF",
                                        }}
                                    />
                                </MDBox>
                            </MDBox>

                            <TextField
                                fullWidth
                                type="number"
                                label={financeText("Opening Balance")}
                                size="small"
                                value={
                                    cashAccountForm.openingBalance
                                }
                                onChange={(
                                    event
                                ) =>
                                    setCashAccountForm(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            openingBalance:
                                            event
                                                .target
                                                .value,
                                        })
                                    )
                                }
                                InputProps={{
                                    startAdornment:
                                        (
                                            <InputAdornment position="start">
                                                {
                                                    selectedBank.currency
                                                }
                                            </InputAdornment>
                                        ),
                                }}
                                inputProps={{
                                    step:
                                        "0.01",
                                }}
                                helperText={financeText("Initial balance of this bank account in Company Cash.")}
                                sx={{
                                    "& .MuiOutlinedInput-root":
                                        {
                                            borderRadius:
                                                "11px",
                                        },
                                }}
                            />

                            <TextField
                                fullWidth
                                multiline
                                minRows={3}
                                label={financeText("Description")}
                                placeholder={financeText("Example: Main EUR collection account")}
                                value={
                                    cashAccountForm.description
                                }
                                onChange={(
                                    event
                                ) =>
                                    setCashAccountForm(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            description:
                                            event
                                                .target
                                                .value,
                                        })
                                    )
                                }
                                sx={{
                                    "& .MuiOutlinedInput-root":
                                        {
                                            borderRadius:
                                                "11px",
                                        },
                                }}
                            />

                            <Alert
                                severity="info"
                                sx={{
                                    borderRadius:
                                        "8px",
                                }}
                            >
                                {financeText(
                                    "After connecting, future balance changes should be managed through Company Cash transactions."
                                )}
                            </Alert>
                        </Stack>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        gap: 1,
                    }}
                >
                    <MDButton
                        variant="contained"
                        disabled={
                            connectingCash
                        }
                        onClick={
                            closeCashAccountModal
                        }
                        sx={getButtonStyle(
                            buttonColors.secondary
                        )}
                    >
                        {financeText("Cancel")}
                    </MDButton>

                    <MDButton
                        variant="contained"
                        disabled={
                            connectingCash
                        }
                        onClick={
                            confirmCashConnection
                        }
                        sx={getButtonStyle(
                            buttonColors.success
                        )}
                    >
                        {connectingCash ? (
                            <CircularProgress
                                size={16}
                                sx={{
                                    color:
                                        "#FFFFFF",

                                    mr: 0.7,
                                }}
                            />
                        ) : (
                            <AccountBalanceWalletOutlined
                                sx={{
                                    mr: 0.7,
                                }}
                            />
                        )}

                        {financeText("Connect Account")}
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* =====================================================
                EDIT DIALOG
            ===================================================== */}

            <Dialog
                open={Boolean(
                    edit
                )}
                onClose={() => {
                    if (
                        !saving
                    ) {
                        setEdit(
                            null
                        );
                    }
                }}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius:
                            "10px",
                    },
                }}
            >
                <DialogTitle>
                    <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1}
                    >
                        <MDBox
                            width={42}
                            height={42}
                            borderRadius="8px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                color:
                                COLORS.purple,

                                background:
                                COLORS.purpleLight,

                                border:
                                    "1px solid #D9D6FE",
                            }}
                        >
                            <EditOutlined />
                        </MDBox>

                        <MDBox>
                            <MDTypography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                    color:
                                    COLORS.text,
                                }}
                            >
                                {financeText("Edit Bank Account")}
                            </MDTypography>

                            <MDTypography
                                variant="caption"
                                sx={{
                                    color:
                                    COLORS.subtext,
                                }}
                            >
                                {financeText("Update bank account information.")}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </DialogTitle>

                <DialogContent>
                    {edit && (
                        <Stack
                            spacing={2}
                            mt={1}
                        >
                            {edit.cashAccountId && (
                                <Alert
                                    severity="info"
                                    sx={{
                                        borderRadius:
                                            "8px",
                                    }}
                                >
                                    {financeText(
                                        "This bank account is connected to Company Cash. Currency cannot be changed."
                                    )}
                                </Alert>
                            )}

                            <TextField
                                label={financeText("Bank Name")}
                                fullWidth
                                size="small"
                                value={
                                    edit.bankName
                                }
                                onChange={(
                                    event
                                ) =>
                                    setEdit(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            bankName:
                                            event
                                                .target
                                                .value,
                                        })
                                    )
                                }
                            />

                            <TextField
                                select
                                label={financeText("Currency")}
                                fullWidth
                                size="small"
                                value={
                                    edit.currency
                                }
                                disabled={Boolean(
                                    edit.cashAccountId
                                )}
                                helperText={
                                    edit.cashAccountId
                                        ? financeText("Currency is locked because this account is connected to Company Cash.")
                                        : ""
                                }
                                onChange={(
                                    event
                                ) =>
                                    setEdit(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            currency:
                                            event
                                                .target
                                                .value,
                                        })
                                    )
                                }
                            >
                                {currencies.map(
                                    (
                                        currency
                                    ) => (
                                        <MenuItem
                                            key={
                                                currency
                                            }
                                            value={
                                                currency
                                            }
                                        >
                                            {
                                                currency
                                            }
                                        </MenuItem>
                                    )
                                )}
                            </TextField>

                            <TextField
                                label={financeText("IBAN")}
                                fullWidth
                                size="small"
                                value={
                                    edit.iban
                                }
                                error={Boolean(
                                    editErrors.iban
                                )}
                                helperText={
                                    editErrors.iban ||
                                    financeText("TR IBAN - 26 characters")
                                }
                                onChange={(
                                    event
                                ) =>
                                    setEdit(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            iban:
                                                formatIBAN(
                                                    event
                                                        .target
                                                        .value
                                                ),
                                        })
                                    )
                                }
                            />

                            <TextField
                                label={financeText("SWIFT Code")}
                                fullWidth
                                size="small"
                                value={
                                    edit.swift
                                }
                                error={Boolean(
                                    editErrors.swift
                                )}
                                helperText={
                                    editErrors.swift ||
                                    financeText("8 or 11 characters")
                                }
                                onChange={(
                                    event
                                ) =>
                                    setEdit(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            swift:
                                                normalizeSwift(
                                                    event
                                                        .target
                                                        .value
                                                ),
                                        })
                                    )
                                }
                            />

                            <TextField
                                label={financeText("Branch")}
                                fullWidth
                                size="small"
                                value={
                                    edit.branch
                                }
                                onChange={(
                                    event
                                ) =>
                                    setEdit(
                                        (
                                            previous
                                        ) => ({
                                            ...previous,

                                            branch:
                                            event
                                                .target
                                                .value,
                                        })
                                    )
                                }
                            />
                        </Stack>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        gap: 1,
                    }}
                >
                    <MDButton
                        variant="contained"
                        disabled={
                            saving
                        }
                        onClick={() =>
                            setEdit(
                                null
                            )
                        }
                        sx={getButtonStyle(
                            buttonColors.secondary
                        )}
                    >
                        {financeText("Cancel")}
                    </MDButton>

                    <MDButton
                        variant="contained"
                        disabled={
                            saving ||
                            !editFormValid
                        }
                        onClick={
                            confirmEdit
                        }
                        sx={getButtonStyle(
                            buttonColors.primary
                        )}
                    >
                        {saving ? (
                            <CircularProgress
                                size={16}
                                sx={{
                                    color:
                                        "#FFFFFF",

                                    mr: 0.7,
                                }}
                            />
                        ) : (
                            <EditOutlined
                                sx={{
                                    mr: 0.7,
                                }}
                            />
                        )}

                        {financeText("Update")}
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* =====================================================
                DELETE DIALOG
            ===================================================== */}

            <Dialog
                open={Boolean(
                    deleteTarget
                )}
                onClose={() => {
                    if (
                        !saving
                    ) {
                        setDeleteTarget(
                            null
                        );
                    }
                }}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius:
                            "10px",
                    },
                }}
            >
                <DialogContent
                    sx={{
                        textAlign:
                            "center",

                        pt: 4,
                    }}
                >
                    <MDBox
                        width={58}
                        height={58}
                        borderRadius="50%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mx="auto"
                        mb={2}
                        sx={{
                            background:
                            COLORS.redLight,
                        }}
                    >
                        <WarningAmberRounded
                            sx={{
                                color:
                                COLORS.red,

                                fontSize:
                                    30,
                            }}
                        />
                    </MDBox>

                    <MDTypography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                            color:
                            COLORS.text,
                        }}
                    >
                        {financeText("Delete Bank Account?")}
                    </MDTypography>

                    <MDTypography
                        variant="body2"
                        mt={1}
                        sx={{
                            color:
                            COLORS.subtext,
                        }}
                    >
                        <strong>
                            {
                                deleteTarget?.bankName
                            }
                        </strong>{" "}
                        {financeText("will be permanently deleted. This action cannot be undone.")}
                    </MDTypography>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent:
                            "center",

                        pb: 3,

                        gap: 1,
                    }}
                >
                    <MDButton
                        variant="contained"
                        disabled={
                            saving
                        }
                        onClick={() =>
                            setDeleteTarget(
                                null
                            )
                        }
                        sx={getButtonStyle(
                            buttonColors.secondary
                        )}
                    >
                        {financeText("Cancel")}
                    </MDButton>

                    <MDButton
                        variant="contained"
                        disabled={
                            saving
                        }
                        onClick={
                            confirmDelete
                        }
                        sx={getButtonStyle(
                            buttonColors.danger
                        )}
                    >
                        {saving ? (
                            <CircularProgress
                                size={16}
                                sx={{
                                    color:
                                        "#FFFFFF",

                                    mr: 0.7,
                                }}
                            />
                        ) : (
                            <DeleteOutlineOutlined
                                sx={{
                                    mr: 0.7,
                                }}
                            />
                        )}

                        {financeText("Delete")}
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* =====================================================
                SNACKBAR
            ===================================================== */}

            <Snackbar
                open={
                    notification.open
                }
                autoHideDuration={4000}
                onClose={
                    closeNotification
                }
                anchorOrigin={{
                    vertical:
                        "bottom",

                    horizontal:
                        "right",
                }}
            >
                <Alert
                    onClose={
                        closeNotification
                    }
                    severity={
                        notification.severity
                    }
                    variant="filled"
                    sx={{
                        width:
                            "100%",

                        borderRadius:
                            "8px",
                    }}
                >
                    {
                        notification.message
                    }
                </Alert>
            </Snackbar>

            <Footer />
        </DashboardLayout>
    );
};

export default BankDetails;